/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { get, camelCase, merge } from 'lodash';
import { ObjectFormData, ObjectType, AttributesGroup, Mapper } from '../types';
import * as Mappers from './mappers';

export default (type: ObjectType): ObjectFormData => {
  const { generic, customAttributes } = Mappers;
  const groupedAttrOrder: AttributesGroup[] = get(Mappers, `${camelCase(type)}.groupAttributeOrder`, []);
  const objectMapper: Mapper = get(Mappers, `${camelCase(type)}.mapper`, {});
  return {
    groupedAttrOrder,
    attrMapper: merge({}, generic, objectMapper, customAttributes),
  };
};
